import { useEffect, useState } from "react";
import { API } from "../../config";

export default function PaymentResult({ kind }) {
    const [payment, setPayment] = useState(null);
    const sessionId = new URLSearchParams(window.location.search).get("session_id");

    useEffect(() => {
        if (kind !== "success" || !sessionId) return undefined;
        let attempts = 0;
        const poll = async () => {
            try {
                const r = await fetch(`${API}/api/payments/status/${sessionId}`);
                if (r.ok) {
                    const data = await r.json();
                    setPayment(data);
                    if (data.payment_status === "paid" || attempts >= 15) return;
                }
            } catch (e) {
                /* transient — keep polling */
            }
            attempts += 1;
            setTimeout(poll, 2000);
        };
        poll();
        return undefined;
    }, [kind, sessionId]);

    const paid = payment?.payment_status === "paid";

    return (
        <div className="min-h-screen bg-[#f2f4f6] tb-grid flex items-center justify-center px-4">
            <div className="w-full max-w-lg rounded-lg bg-white border border-subtle p-8 font-mono shadow-2xl">
                <div className="text-cyan-600 text-[10px] tracking-[0.35em] uppercase mb-6">
                    Timbotic Procurement Portal
                </div>
                {kind === "success" ? (
                    <>
                        <h1
                            data-testid="payment-success-heading"
                            className="text-xl font-bold text-slate-900 mb-6"
                        >
                            {paid ? "DONATION RECEIVED." : "CONFIRMING DONATION..."}
                        </h1>
                        <div className="space-y-2 text-xs text-slate-600">
                            <div className="flex justify-between">
                                <span>PAYMENT STATUS</span>
                                <span className={paid ? "text-emerald-600 font-bold" : "text-amber-600"}>
                                    {paid ? "PAID" : "PENDING"}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span>FUND ALLOCATION</span>
                                <span className="text-slate-900">DGX SPARK (EVENTUALLY)</span>
                            </div>
                            <div className="flex justify-between">
                                <span>EQUITY ISSUED</span>
                                <span className="text-slate-900">NONE (AS ADVERTISED)</span>
                            </div>
                            <div className="flex justify-between">
                                <span>TIM GRATITUDE</span>
                                <span className="text-emerald-600 font-bold">GENUINE</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <h1
                            data-testid="payment-cancel-heading"
                            className="text-xl font-bold text-slate-900 mb-6"
                        >
                            DONATION ABORTED.
                        </h1>
                        <div className="space-y-2 text-xs text-slate-600">
                            <div className="flex justify-between">
                                <span>FUND STATUS</span>
                                <span className="text-slate-900">UNCHANGED ($0)</span>
                            </div>
                            <div className="flex justify-between">
                                <span>HARDWARE FEELINGS</span>
                                <span className="text-amber-600">HURT</span>
                            </div>
                            <div className="flex justify-between">
                                <span>JUDGEMENT</span>
                                <span className="text-slate-900">NONE. THE WISHLIST REMAINS.</span>
                            </div>
                        </div>
                    </>
                )}
                <a
                    href="/"
                    data-testid="payment-return-button"
                    className="mt-8 inline-block px-6 py-3 rounded bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-xs tracking-widest uppercase transition-colors"
                >
                    Return to the Lab
                </a>
            </div>
        </div>
    );
}
